import React from 'react'
//redux
import { useDispatch, useSelector } from 'react-redux'
import {
  courseGetSuccess,
  //assignmentReportAction,
} from 'src/reducers/course/action'
// @mui
import { Paper, Typography, Box, Tooltip, withStyles } from '@material-ui/core'
// components
import CourseToolBar from './course-tool-bar'
import URL from 'src/api/url/api'
import styles from './styles'
import { Icon } from '@iconify/react'
import { useHistory } from 'react-router-dom'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { getCardSuccess } from 'src/reducers/card/action'
import { useParams } from 'react-router-dom'
// ----------------------------------------------------------------------

const CourseCard = props => {
  const { course, index, setLocalCourses, localCourses, classes } = props
  const history = useHistory()
  const dispatch = useDispatch()
  const { name, thumbnail } = course

  const handleClick = course => {
    dispatch(getCardSuccess(null))
    dispatch(courseGetSuccess(null))
    history.push('/mini-course/' + course.id + '/page')
    window.scrollTo(0, 0)
  }

  const { id } = useParams()

  const [onHover, setOnHover] = React.useState(false)

  const coverImage =
    thumbnail === null || thumbnail === '' || thumbnail === undefined
      ? 'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/Default.png'
      : thumbnail.includes('http')
      ? thumbnail
      : URL.CDN + thumbnail

  // DnD Kit
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
    over,
  } = useSortable({ id: `${course.id}-item` })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: 1000,
  }

  return (
    <>
      <div ref={setNodeRef} style={style} {...attributes}>
        <Paper
          onMouseEnter={() => {
            setOnHover(true)
          }}
          onMouseLeave={() => {
            setOnHover(false)
          }}
          className={classes.courseGalleryView}
          style={{
            outline: isDragging ? '1px solid #015FFB' : 'none',
          }}
        >
          <div
            style={{
              backgroundImage: `url(${coverImage})`,
            }}
            className={classes.coverImage}
            onClick={() => handleClick(course)}
          >
            {onHover && id !== undefined && (
              <div className={classes.hoverContainer}>
                <div className={classes.flexGrowContainer}></div>

                <Icon
                  {...listeners}
                  draggable
                  width={24}
                  height={24}
                  icon="eva:move-fill"
                  className={classes.moveIcon}
                />
              </div>
            )}
          </div>
          <div className={classes.courseContent}>
            <div className={classes.miniCourseIcon}>
              <Typography className={classes.miniCourseText}>
                MINI COURSE
              </Typography>
              <Icon icon="mage:book" width="20" height="20" />
            </div>
            <div
              className={classes.courseNameBox}
              onClick={() => {
                handleClick(course)
              }}
            >
              <Tooltip
                title={course?.name?.length > 81 ? course?.name : ''}
                placement="bottom"
              >
                <Typography className={classes.courseNameTypography} noWrap>
                  {name}
                </Typography>
              </Tooltip>
            </div>

            <div className={classes.toolbarContainer}>
              <Typography
                variant="caption"
                fontSize="12px"
                fontWeight={400}
                style={{
                  color: '#919EAB',
                }}
              >
                {course.createdAt
                  ? new Date(course.createdAt).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })
                  : ''}
              </Typography>
              {(id !== undefined || window.location.pathname == '/courses') && (
                <CourseToolBar
                  course={course}
                  setLocalCourses={setLocalCourses}
                  localCourses={localCourses}
                />
              )}
            </div>
          </div>
        </Paper>
      </div>
    </>
  )
}

export default withStyles(styles)(CourseCard)
